/* global BX, bitrix_sessid, FormUtils */

(function () {
    'use strict';
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;

    const modalId = 'review-modal-overlay';
    const closeBtnId = 'review-modal-close-btn';
    const submitBtn = document.getElementById('review-submit-btn');
    const commonErrorsBlock = document.getElementById('review-form-common-errors');
    const captchaContainerId = 'review-captcha-container';
    const containerSelector = '#review-modal-content';

    const nameInput = document.getElementById('review-name');
    const emailInput = document.getElementById('review-email');
    const textInput = document.getElementById('review-text');
    const avatarInput = document.getElementById('review-avatar');
    const fileInput = document.getElementById('review-file');
    const avatarBtn = document.getElementById('review-avatar-btn');
    const fileBtn = document.getElementById('review-file-btn');
    const avatarText = document.getElementById('review-avatar-text');
    const fileText = document.getElementById('review-file-text');

    const ratingStars = document.querySelectorAll('#review-rating-stars .review-rating__star');
    const ratingLabel = document.getElementById('review-rating-label');
    const ratingError = document.getElementById('review-rating-error');
    const ratingLabels = ['очень плохо', 'плохо', 'нормально', 'хорошо', 'отлично'];
    let selectedRating = 0;

    if (!document.getElementById(modalId) || !submitBtn) return;

    FormUtils.setupFileButton(avatarBtn, avatarInput, avatarText);
    FormUtils.setupFileButton(fileBtn, fileInput, fileText);

    const initCaptcha = () => FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = () => FormUtils.resetCaptcha();

    const updateStarsDisplay = (hoverValue = 0) => {
        ratingStars.forEach((star, index) => {
            const value = index + 1;
            star.classList.remove('active');
            if (hoverValue) {
                if (value <= hoverValue) star.classList.add('active');
            } else if (selectedRating && value <= selectedRating) {
                star.classList.add('active');
            }
        });

        if (hoverValue) {
            ratingLabel.textContent = ratingLabels[hoverValue - 1] || 'без оценки';
        } else if (selectedRating) {
            ratingLabel.textContent = ratingLabels[selectedRating - 1];
        } else {
            ratingLabel.textContent = 'без оценки';
        }
    };

    ratingStars.forEach((star) => {
        star.addEventListener('mouseenter', function () {
            updateStarsDisplay(parseInt(this.getAttribute('data-value'), 10));
        });
        star.addEventListener('mouseleave', () => updateStarsDisplay(0));
        star.addEventListener('click', function () {
            selectedRating = parseInt(this.getAttribute('data-value'), 10);
            updateStarsDisplay(0);
            if (ratingError) {
                ratingError.textContent = '';
                ratingError.parentElement.classList.remove('error');
            }
        });
    });

    const clearFields = () => {
        nameInput.value = '';
        emailInput.value = '';
        textInput.value = '';
        selectedRating = 0;
        updateStarsDisplay(0);
        if (avatarInput) {
            avatarInput.value = '';
            if (avatarText) avatarText.textContent = 'ничего не выбрано';
        }
        if (fileInput) {
            fileInput.value = '';
            if (fileText) fileText.textContent = 'ничего не выбрано';
        }
    };

    const hideErrors = () => {
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
        if (ratingError) {
            ratingError.textContent = '';
            ratingError.parentElement.classList.remove('error');
        }
    };

    const validate = () => {
        let isValid = true;
        hideErrors();

        if (!FormUtils.validateRequired(nameInput.value)) {
            FormUtils.showFieldError(nameInput, '*Обязательное поле');
            isValid = false;
        }

        if (selectedRating === 0) {
            if (ratingError) {
                ratingError.textContent = '*Поставьте оценку';
                ratingError.parentElement.classList.add('error');
            }
            isValid = false;
        }

        if (!FormUtils.validateRequired(textInput.value)) {
            FormUtils.showFieldError(textInput, '*Обязательное поле');
            isValid = false;
        }

        if (!FormUtils.validateRequired(emailInput.value)) {
            FormUtils.showFieldError(emailInput, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validateEmail(emailInput.value)) {
            FormUtils.showFieldError(emailInput, '*Введите корректный E-mail');
            isValid = false;
        }

        const fileInputs = [
            {input: avatarInput, allowed: ['jpg', 'jpeg', 'png', 'gif'], maxSize: 5 * 1024 * 1024, name: 'аватар'},
            {
                input: fileInput,
                allowed: ['pdf', 'doc', 'docx', 'txt', 'rtf', 'jpg', 'jpeg', 'png'],
                maxSize: 10 * 1024 * 1024,
                name: 'файл',
            },
        ];
        fileInputs.forEach(({input, allowed, maxSize, name}) => {
            if (input && input.files.length > 0) {
                const file = input.files[0];
                const ext = file.name.split('.').pop().toLowerCase();
                if (!allowed.includes(ext)) {
                    FormUtils.showFieldError(input, `*Недопустимый формат для ${name}: ${allowed.join(', ')}`);
                    isValid = false;
                } else if (file.size > maxSize) {
                    const sizeMB = Math.round(maxSize / (1024 * 1024));
                    FormUtils.showFieldError(input, `*Размер ${name} не должен превышать ${sizeMB} МБ`);
                    isValid = false;
                }
            }
        });

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, 'Подтвердите, что вы не робот');
            isValid = false;
        }

        if (!isValid) {
            const firstError = document.querySelector(
                containerSelector +
                    ' .form-content__group.error, ' +
                    containerSelector +
                    ' .form-content__file-wrapper.error, ' +
                    containerSelector +
                    ' .review-rating.error'
            );
            if (firstError) {
                firstError.scrollIntoView({behavior: 'smooth', block: 'center'});
            } else if (commonErrorsBlock && commonErrorsBlock.style.display === 'flex') {
                commonErrorsBlock.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
        }
        return isValid;
    };

    const send = async () => {
        if (!validate()) return;

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token =
            typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';

        const payload = {
            name: nameInput.value,
            email: emailInput.value,
            rating: selectedRating,
            text: textInput.value,
            smart_token: captchaToken ? captchaToken.value : '',
        };

        if (submitBtn) submitBtn.disabled = true;

        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/review',
                payload,
                files: [
                    {fieldName: 'avatar', fileInputElement: avatarInput},
                    {fieldName: 'attachment', fileInputElement: fileInput},
                ],
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                submitBtn,
                commonErrorsBlock,
                containerSelector,
                onSuccess: (result) => {
                    alert(result.message || 'Спасибо! Ваш отзыв отправлен.');
                    close();
                },
                onFieldError: (field, msg) => {
                    if (field === 'rating') {
                        if (ratingError) {
                            ratingError.textContent = msg;
                            ratingError.parentElement.classList.add('error');
                        }
                    } else {
                        const el = document.getElementById('review-' + field);
                        if (el) FormUtils.showFieldError(el, msg);
                    }
                },
            });
        } finally {
            if (submitBtn) submitBtn.disabled = false;
        }
    };

    const open = () => {
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        hideErrors();
        initCaptcha();
        resetCaptcha();
        updateStarsDisplay(0);
    };

    const close = () => {
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        resetCaptcha();
    };

    FormUtils.createModal({
        modalId,
        closeBtnId,
        openBtnClass: '.open-review-btn',
        onOpen: open,
        onClose: close,
    });

    submitBtn.addEventListener('click', send);
})();
